<template>
    <div id="footer" class="footer">
        <div class="footer-main">
            <div class="friends-link">
                <span>友情链接：</span>
                <a href="http://www.gongkong.com/" target="_blank">中国工控网</a>
                <a href="http://www.gongkongmall.com/" target="_blank">工控猫</a>
                <a href="http://www.gongkongedu.com/" target="_blank">工控教育</a>
                <a href="http://www.gongkong.com/hr/index.html" target="_blank">工控人才</a>
                <a href="http://video.gongkong.com/" target="_blank">工控网视频</a>
                <a href="http://www.shuigongye.com/" target="_blank">中国水工业网</a>
                <a href="http://www.chinaopc.org/" target="_blank">OPC中国</a>
                <a href="http://www.gkquan.com/" target="_blank">工控圈</a>
                <a href="http://www.casicloud.com" target="_blank">航天云网</a>
                <a href="http://www.gepresearch.com" target="_blank">环保研究网</a>
                <a href="http://www.insupai.com/Help/helpCenter_19.html">更多</a>
            </div>
            <div class="sp-copyright">
                <span>版权所有：Copyright&nbsp;<i>©</i>&nbsp;insupai.com</span>
                <span>京公网安备：110108902160</span>
                <span>电信业务审批【2014】字第180号</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    }
}
</script>
<style lang="scss">

#footer {
    padding: 20px 0;
}

#footer footer-main {
    width: 1000px;
    margin: 0 auto;
}

#footer .friends-link {
    height: 26px;
    line-height: 26px;
    text-align: center;
}

#footer .friends-link a,
#footer .friends-link span {
    display: inline-block;
    vertical-align: top;
    color: #999;
}

#footer .friends-link a:hover {
    color: #f75959;
}

#footer .sp-copyright {
    text-align: center;
    line-height: 26px;
    color: #999;
    height: 26px;
}

#footer .sp-copyright>* {
    font-size: 14px;
    display: inline-block;
    vertical-align: top;
    height: 26px;
    margin-right: 10px;
}
</style>